import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { THEMES } from '../../../data/product/product.data';
import { URLS } from '../../../data/navigation/navigation.data';
import { Product } from '../../../model/product/product.model';
import { ChromeThemeBridgeService } from '../../../service/chrome-theme-bridge/chrome-theme-bridge.service';
import { CookieConsentService } from '../../../service/cookie-consent/cookie-consent.service';

// Bottom toast that appears only when the visitor has Codigrate's "All In One
// Themes" Chrome extension installed with a theme selected, and the site is not
// already wearing it. It OFFERS to match the site skin to the browser theme;
// applying only happens when the user clicks Match. Mirrors <app-cookies> in
// placement (a sibling of <router-outlet> at the app root).
@Component( {
  selector: 'app-theme-offer',
  templateUrl: './theme-offer-popup.component.html',
  styleUrls: [ './theme-offer-popup.component.scss' ]
} )
export class ThemeOfferPopupComponent implements OnInit {

  URLS = URLS;

  offeredTheme: Observable<Product | null>;
  // True while the cookie bar is still showing, the offer raises itself to sit
  // above it, then drops back down once cookies are accepted.
  cookieVisible = false;

  constructor(
    private bridge: ChromeThemeBridgeService,
    private consent: CookieConsentService,
  ) {
    this.offeredTheme = this.bridge.offeredTheme;
  }

  ngOnInit(): void {
    this.bridge.start();
    this.consent.accepted.subscribe( accepted => this.cookieVisible = !accepted );
  }

  // The theme's category (its product-line name, e.g. 'nature' / 'cities'),   // the theme page needs both `product` and `category` query params.
  categoryOf( theme: Product ): string {
    for ( const line of THEMES ) {
      if ( line.products.some( p => p.key === theme.key ) ) {
        return line.name;
      }
    }
    return '';
  }

  accept(): void {
    this.bridge.accept();
  }

  dismiss(): void {
    this.bridge.dismiss();
  }
}
